<!-- <mat-icon class="close-button" (click)="closeDialogue()">highlight_off</mat-icon> -->
<div class="w-100 flex justify-end">
  <span class="material-icons text-3xl dialog-close" (click)="dialogRef.close()">
  close
</span>
</div>
<mat-tab-group class="order-details-tabs">
  <mat-tab label="Order Overview">
    <table mat-table [dataSource]="dataSourceOrder" class="order-details-table w-full">

      <!--- Note that these columns can be defined in any order.
            The actual rendered columns are set as a property on the row definition" -->

      <ng-container matColumnDef="itemName">
        <th mat-header-cell *matHeaderCellDef> Item Name </th>
        <td mat-cell *matCellDef="let element"> {{element.itemName}} </td>
      </ng-container>

      <ng-container matColumnDef="quantity">
        <th mat-header-cell *matHeaderCellDef> Qty </th>
        <td mat-cell *matCellDef="let element"> {{element.quantity}} </td>
      </ng-container>

      <ng-container matColumnDef="amount">
        <th mat-header-cell *matHeaderCellDef> Amount </th>
        <td mat-cell *matCellDef="let element"> {{element.amount}} </td>
      </ng-container>


      <tr mat-header-row *matHeaderRowDef="displayedColumnsOrder"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumnsOrder;"></tr>
    </table>

  </mat-tab>
  <mat-tab label="Shipping Details">

    <form class="w-full max-w-sm" [formGroup]="shippingGroup" disabled="true">
      <div class="md:flex justify-evenly md:items-center mb-2 p-2">
        <div class="md:w-1/3">
          <label class="block text-gray-700 text-sm md:text-md pl-1 mb-1 md:mb-0 pr-4" for="inline-recipient">
            Recipient
          </label>
        </div>
        <div class="md:w-1/2">
          <input class="appearance-none block w-full bg-transparent text-gray-700 border-b border-teal-500 mb-3 leading-tight focus:outline-none" id="inline-recipient" type="text" [value]="recipient" readonly disabled="true">
        </div>
      </div>
      <div class="md:flex justify-evenly md:items-center mb-2 p-2">
        <div class="md:w-1/3">
          <label class="block text-gray-700 text-sm md:text-md pl-1 mb-1 md:mb-0 pr-4" for="inline-recipient">
            Address Line 1
          </label>
        </div>
        <div class="md:w-1/2">
          <input class="appearance-none block w-full bg-transparent text-gray-700 border-b border-teal-500 mb-3 leading-tight focus:outline-none" id="inline-recipient" type="text" [value]="shippingAddress1" readonly disabled="true">
        </div>
      </div>
      <div class="md:flex justify-evenly md:items-center mb-2 p-2">
        <div class="md:w-1/3">
          <label class="block text-gray-700 text-sm md:text-md pl-1 mb-1 md:mb-0 pr-4" for="inline-recipient">
            Address Line 2
          </label>
        </div>
        <div class="md:w-1/2">
          <input class="appearance-none block w-full bg-transparent text-gray-700 border-b border-teal-500 mb-3 leading-tight focus:outline-none" id="inline-recipient" type="text" [value]="shippingAddress2" readonly disabled="true">
        </div>
      </div>
      <div class="md:flex justify-evenly md:items-center mb-2 p-2">
        <div class="md:w-1/3">
          <label class="block text-gray-700 text-sm md:text-md pl-1 mb-1 md:mb-0 pr-4" for="inline-recipient">
            Address Line 3
          </label>
        </div>
        <div class="md:w-1/2">
          <input class="appearance-none block w-full bg-transparent text-gray-700 border-b border-teal-500 mb-3 leading-tight focus:outline-none" id="inline-recipient" type="text" [value]="shippingAddress3" readonly disabled="true">
        </div>
      </div>
      <div class="md:flex justify-evenly md:items-center mb-2 p-2">
        <div class="md:w-1/3">
          <label class="block text-gray-700 text-sm md:text-md pl-1 mb-1 md:mb-0 pr-4" for="inline-addr1">
            Address Line 4
          </label>
        </div>
        <div class="md:w-1/2">
          <input class="appearance-none block w-full bg-transparent text-gray-700 border-b border-teal-500 mb-3 leading-tight focus:outline-none" id="inline-addr1" type="text" [value]="shippingAddress4" readonly disabled="true">
        </div>
      </div>
      <div class="md:flex justify-evenly md:items-center mb-2 p-2">
        <div class="md:w-1/3">
          <label class="block text-gray-700 text-sm md:text-md pl-1 mb-1 md:mb-0 pr-4" for="inline-recipient">
            Address Line 5
          </label>
        </div>
        <div class="md:w-1/2">
          <input class="appearance-none block w-full bg-transparent text-gray-700 border-b border-teal-500 mb-3 leading-tight focus:outline-none" id="inline-recipient" type="text" [value]="shippingAddress5" readonly disabled="true">
        </div>
      </div>
    </form>

  </mat-tab>
</mat-tab-group>
